import { CSSProperties, ReactNode, useContext } from "react";
import { ViewerContext } from "dash-ui";

import { AnalyticsEvent, trackEvent } from "shared/analytics";

const REST_API_DOMAIN = process.env["REACT_APP_REST"];

interface LinkToCustomerPortalProps {
  className?: string;
  children?: ReactNode;
  style?: CSSProperties;
  source?: string;
}

/** Opens the Stripe customer portal, where the broker manages cards and invoices. */
export function LinkToCustomerPortal({
  className = "",
  children,
  style,
  source = "profile_billing",
}: LinkToCustomerPortalProps) {
  const { account } = useContext(ViewerContext);

  return (
    <a
      className={`hover:opacity-90 ${className}`}
      style={style}
      onClick={() =>
        trackEvent(AnalyticsEvent.BILLING_PORTAL_OPENED, { source })
      }
      href={`${REST_API_DOMAIN}/stripe/create-portal-session?customerId=${account?.stripeCustomerId}`}
    >
      {children}
    </a>
  );
}
